import { createContext, useContext, useEffect, useState } from "react";

export const TEXT_SIZES = ["compact", "comfortable", "large"];
const ThemeCtx = createContext({ theme: "light", setTheme: () => {}, collapsed: false, setCollapsed: () => {}, textSize: "comfortable", setTextSize: () => {} });
const read = (k, d) => { try { return localStorage.getItem(k) || d; } catch { return d; } };

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => read("vis-theme", "light"));
  const [collapsed, setCollapsed] = useState(() => read("vis-sidebar", "open") === "collapsed");
  const [textSize, setTextSize] = useState(() => { const v = read("vis-text", "comfortable"); return TEXT_SIZES.includes(v) ? v : "comfortable"; });
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { localStorage.setItem("vis-theme", theme); } catch {}
  }, [theme]);
  useEffect(() => {
    document.documentElement.setAttribute("data-text", textSize);
    try { localStorage.setItem("vis-text", textSize); } catch {}
  }, [textSize]);
  useEffect(() => { try { localStorage.setItem("vis-sidebar", collapsed ? "collapsed" : "open"); } catch {} }, [collapsed]);
  return <ThemeCtx.Provider value={{ theme, setTheme, collapsed, setCollapsed, textSize, setTextSize }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
